/**
 * TODAY, FOR WHATEVER DRAWS A DAY - the day the platform's clock is in, which ./MonthGrid.tsx marks
 * on the month (the owner's list, 2026-10-05, item 7: the Calendar had no "today").
 *
 * This app keeps no clock (routes/calendar/CalendarRoute.tsx, "THE MONTH"), so today is not
 * something a component can work out for itself: it is a RESPONSE, `getPaymentsView`'s
 * `computedAt`, read once per visit and cut to a day key by routes/calendar/platform-month.ts. The
 * route provides it here; the grid reads it.
 *
 * WHY A CONTEXT AND NOT A PROP. The day is a fact about the visit, not about the month on screen:
 * the grid sits under the route's month component, whose props describe one month, and the visit's
 * day passes by it the way a locale would. And CalendarRoute's lines are cited by number from
 * other files (docs/audit/post-build-review-2026-09-27/U1.md), which a prop threaded through that
 * component would have moved.
 *
 * UNDEFINED MARKS NO DAY - before the read has landed, when it failed, and with no provider at all
 * (a spec, a preview). Never a guess.
 */
import { createContext, useContext } from 'react';

const CalendarTodayContext = createContext<string | undefined>(undefined);

/** `value` is a `YYYY-MM-DD` day key, spelt as `daysOfMonth` spells a cell's, or undefined. */
export const CalendarTodayProvider = CalendarTodayContext.Provider;

/** The day the platform's clock is in, if the screen has read it. */
export function useCalendarToday(): string | undefined {
  return useContext(CalendarTodayContext);
}
